import * as React from 'react';
import { OnClickOutside } from '../on-click-outside';
import { HotKeys } from 'react-hotkeys';
import { PromptConfirmation } from './prompt-confirmation';
import { PromptConfirmationProps, PromptModalState } from './types';
import { withDropdownMenu } from 'ui/common/dropdown-menu';
import { DropdownMenuContext } from '../dropdown-menu/types';

/**
 * DEPRECATED. Use input-modal-host instead.
 */
export class PromptConfirmationComponentModal extends React.Component<
  PromptConfirmationProps & DropdownMenuContext & React.PropsWithChildren, PromptModalState> {
  public state: Readonly<PromptModalState> = {
    isOpen: false
  };

  public handleClick = (e: React.SyntheticEvent<any>) => {
    e && e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private handleHide = () => {
    this.props.handleDropdownHide && this.props.handleDropdownHide();
    this.setState({
      isOpen: false
    });
  };

  private handleContinue = () => {
    this.handleHide();
    this.props.onContinue && this.props.onContinue();
  };

  private handleCancel = () => {
    this.handleHide();
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  private keyMap: any = {
    escapeKey: ['esc']
  };

  private handlerHotkeys: any = {
    escapeKey: () => this.handleHide()
  };

  public render() {

    if (!this.state.isOpen) {
      return React.cloneElement(this.props.children as React.ReactElement<any>, { onClick: this.handleClick });
    }

    return <HotKeys keyMap={this.keyMap} handlers={this.handlerHotkeys}>
      <OnClickOutside onClickOutside={this.handleHide}>
        {this.props.children}
        <PromptConfirmation {...this.props} onContinue={this.handleContinue} onCancel={this.handleCancel} />
      </OnClickOutside>
    </HotKeys>;
  }
}

const component = withDropdownMenu(PromptConfirmationComponentModal);

export { component as PromptConfirmationModal };
